import React from "react";
import { Button, Paper, ClickAwayListener, FormControlLabel, Checkbox } from "@material-ui/core";

class StatementTaxesDownloadPopper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            separateMonthTabs: false,
        };
    }

    handleClose = () => {
        this.props.handleClosePopper();
    };

    handleDownload = () => {
        this.props.callback(this.state.separateMonthTabs);
        this.props.handleClosePopper();
    };

    render() {
        return (
            <ClickAwayListener onClickAway={this.handleClose}>
                <Paper style={{ padding: "16px", minWidth: "260px" }}>
                    <div style={{ marginBottom: "16px" }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.separateMonthTabs}
                                    onChange={(e) =>
                                        this.setState({ separateMonthTabs: e.target.checked })
                                    }
                                    color="primary"
                                />
                            }
                            label="Create a separate tab for each month"
                        />
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                        <Button
                            variant="contained"
                            onClick={this.handleClose}
                            style={{ width: "100px" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleDownload}
                            style={{ width: "100px" }}
                        >
                            Download
                        </Button>
                    </div>
                </Paper>
            </ClickAwayListener>
        );
    }
}

export default StatementTaxesDownloadPopper;